<style>
    .fist-time-chat {
      float: left;
    }
  
    .fist-time-formprompt .position-fixed {
      left: 0;
      width: calc(100% - 19%);
      padding-left: 0;
    }
  
    .fist-time-formprompt .bg-card-light {
      background: none;
    }
  </style>
  <div *ngIf="loaderShow">
    <app-loader></app-loader>
  </div>
  <main>
  
    <div *ngIf="!isUserHaveAccess">
  
      <div class="row m-t-30">
        <div class="col-xs-12 text-center">
          <h1 class="font-h4 weight-400 m-b-15"> {{ChatbotAccessText}} </h1>
  
        </div>
      </div>
    </div>
  
    <div *ngIf="isUserHaveAccess">
      <div class="row">
        <div *ngIf="ShowChatHistory && ConversationHistoryCount>0"
          class="col-lg-3 col-md-3 col-sm-12 col-xs-12 position-sticky p-t-10 no-scroll-x bg-gray-50 chat-scroll">
          <div *ngIf="!IsFirstTime">
            <div class="chat-panel-total">  
              <div class="chat-panel-history-old" id='chat-history-panel'>
                <div class="chat-conversation-header">
                  <p class="black-400 font-subheading1-sm m-b-12 p-l-0">Conversation History
                    ({{getConversationHistoryCount()}})
                  </p>
  
                  <button title="Close History" href="javascript:void(0)" (click)="DisableChatHistory()"
                    class="btn-collapse-history" id='chat-history-close-button'>
                    <i class="icon-close1 m-t-16 pull-left"></i>
                  </button>
                </div>
                <div class="list-view" *ngFor="let item of chatSessionList; let i = index">
                  <div class="list-view-inner" [ngClass]="{'chat-active' : item.is_selected}"
                    *ngIf="item.chat_name !== 'New Topic'">
                    <div class="list-view-chatname-input">
                      <div class="list-view-chatname flex-container-row" (click)="SelectedSession(i)">
                        <span title="{{item.chat_name}}">
                          <b *ngIf="vectorDbDatasets.length>1">{{item.module_name}}</b>
                          {{item.chat_name && (item.chat_name).length > 35 ? ((item.chat_name) | slice:0:35) + '...' : (item.chat_name)}}
                        </span>
                        <div class="text-right chat-history-icons" id='chat-history-menu-icons'>
                          <button title="menu" (click)="toggleDropdown(i, $event)" id='chat-history-menu-icon'>
                            <i class="fa-solid fa-ellipsis-vertical" ></i>
                          </button>
  
                          <div class="popup-backdrop" *ngIf="item.isDeleting || item.is_edited"
                            (click)="$event.stopPropagation()">
                            <ng-container *ngIf="item.isDeleting">
                              <div class="popup">
                                <div class="popup-header">
                                  <h1>Delete session?</h1>
                                </div>
                                <div class="popup-body">
                                  <p>Do you wish to delete this session?</p>
                                </div>
                                <div class="popup-footer">
                                  <button (click)="DeleteChatSession(i)" class="button primary"
                                    id='delete_chat_confrim_button'>Confirm</button>
                                  <button (click)="deletedisablepopup(i)" class="button"
                                    id='delete_chat_cancel_button'>Cancel</button>
  
  
                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="item.is_edited">
                              <div class="popup">
                                <div class="popup-header">
                                  <h1>Rename this session</h1>
                                </div>
                                <div class="popup-body">
                                  <input type="text" [(ngModel)]="item.chat_name" class="margin-2 margin-top-5"
                                    id="rename_chat_text_input">
                                </div>
                                <div class="popup-footer">
                                  <button (click)="UpdateChatSession(i)" class="button primary"
                                    id='rename_chat_save_button'>Save</button>
                                  <button (click)="disablepopup(i, $event)" class="button"
                                    id='rename_chat_cancel_button'>Cancel</button>
  
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
  
                      </div>
  
                      <div [ngClass]="{'show': item.dropdownVisible}" class="chat-history-menu">
                        <button title="edit" href="javascript:void(0)" (click)=" Editpopup(i); $event.stopPropagation();"
                          id='chat-history-menu-edit-icon' class='chat-history-rename-delete'>
                          <i class="icon-edit-3 p-r-5"></i> Rename
                        </button>
                        <button title="delete" href="javascript:void(0)"
                          (click)="Deletepopup(i); $event.stopPropagation();" id='chat-history-menu-delete-icon'
                          class='chat-history-rename-delete'>
                          <i class="icon-trash-2 p-r-5"></i> Delete
                        </button>
                      </div>
                    </div>
                  </div>
  
  
                </div>
              </div>
            </div>
  
          </div>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 p-r-0 chat-right-box"
          [ngClass]="{'fullwidth-response': !ShowChatHistory || ConversationHistoryCount === 0}">
          <div *ngIf="!IsFirstTime" class="chat-expandable-area" id='chat-expandable-area'>
            <div *ngIf="DeleteSuccessMessage || EditSuccessMessage" class="toast" id='toast_message'>
              <div>
                <!-- <h1>Success</h1> -->
                <a title="Close" href="javascript:void(0)" (click)="CloseSuccessMessage()"
                  id='success_message_close_button'>
                  <i class="icon-close1 m-t-16 pull-left" style="color: #31ad5f;"></i>
                </a>
              </div>
              <div>
                <p *ngIf="DeleteSuccessMessage" id='delete_chat_success_message'>successfully deleted the chat</p>
                <p *ngIf="EditSuccessMessage" id='edit_chat_success_message'>Chat updated successfully.</p>
              </div>
            </div>
  
            <div *ngIf="IsCustomErrorMessageVisible"  class="toast error" id='toast_message'>
              <div>
                <h1>Error</h1>
                <a title="Close" href="javascript:void(0)" (click)="CloseSuccessMessage()"
                  id='success_message_close_button'>
                  <i class="icon-close1 m-t-16 pull-left" style="color: #ffffff;"></i>
                </a>
              </div>
              <div>
                <p  id='custom_error_message' style="color: #ffffff !important;">{{CustomErrorMessageText}}</p>
              </div>
            </div>
  
            <app-newchat [moduleName]="moduleName" [userFName]="userFName" (buttonClick)="PopularQuestionClick($event)"
              *ngIf="IsNewChat"></app-newchat>
            <div class="response-history-area" *ngIf="!IsNewChat">
              <div class="scrollDiv" *ngFor="let chatdata of ChatQueriesList;  let chatCount = index">
                <div class="card position-relative radius-6">
                  <div *ngIf="(chatCount !== (ChatQueriesList.length - 1))">
                    <div class="d-flex align-items-center justify-content-between m-b-8 chat-message-not-last-sq p-l-2">
                      <div class="d-flex align-items-center chat-message-not-last-sq fullwidth">
                        <div class="card-text-name m-r-22 chat-message-not-last-sq">{{DisplayName}}</div>
                        <div *ngIf="!showEdit" class="card-text-prompt">
                          <h6 class="font-subheading1 m-t-0 m-b-0 text-line20 chat-message-not-last-sq"
                            [innerHtml]="chatdata.question" id='user_question1'>
                          </h6>
                        </div>
                        <div *ngIf="showEdit" class="card-text-prompt">
                          <span class="black-400 chat-message-not-last-sq" contenteditable="true"
                            (input)="onSpanInput($event)" [innerHtml]="chatdata.question"></span>
                        </div>
                      </div>
                    </div>
                    <!-- /* istanbul ignore next */ -->
                    <div class="card pull-left p-l-10 fullwidth chat-message-not-last-sq class1">
                      <div class="response-info-total class1">
                        <div class="response-info-icon class1">
                          <img src="../../assets/images/chatbot-icon.svg" alt="Freya">
                        </div>
                        <div class="response-info-text">
                          <div class="row m-b-20">
                            <div class="col-12">
                              <p class="m-t-0 m-b-10" [innerHtml]="chatdata.answer | replaceDoubleStar| safeHtml ">
                              </p>
                            </div>
                          </div>
  
                          <div
                            *ngIf="(chatdata.metadata|json)!='{}' && !note && selected_module_name == 'view_access_to_regulations'">
                            <div *ngFor="let data of getMetadataForDisplay(chatdata);" class="row">
                              <!-- /* istanbul ignore next */ -->
                              <div *ngFor="let insight of data| keys let i = index" class="col-6 display-grid m-b-15">
                                <div>
                                  <div class="product-panel__bg1">
                                    <div class="product_panel">
                                      <a target="_blank" class="m-b-4" [href]="getInsightViewURLForHref(insight?.ins_id)"
                                        rel="noopener">
                                        {{insight?.ins_id}}
                                      </a>
                                      <h4>{{i+1}}. {{insight?.title | slice:0:62}}{{insight?.title && insight.title.length > 62 ? '...' : ''
                                        }}</h4>
                                    </div>
                                    <div class="product_panel_body">
                                      <p class="p-b-4" *ngIf="insight.ref_url">
                                        <span>Reference: </span>
                                        <ng-container *ngFor="let url of insight?.ref_url | refUrl let i = index">
                                          <span *ngIf="i != 0">, </span>
                                          <a [href]="url" target="_blank">Reference {{i+1}}</a>
                                        </ng-container>
                                      </p>
                                      <p class="p-b-4" *ngIf="insight.attachment_name">
                                        <span class="pull-left">Associated Documents :&nbsp; </span>
  
                                        <ng-container
                                          *ngFor="let attach of insight?.attachment_name | attachmentName let att = index">
                                          <div class="associate-doc-list">
                                            <span *ngIf="att != 0">, </span>
                                            <a (click)="viewFile(attach,'newTab',insight.ins_id)" rel="noopener"> Document {{att+1}} </a>
                                            <a (click)="viewFile(attach,'sameTab',insight.ins_id)" class="ex_icon t-bottom t-sm"
                                              data-tooltip="Download" rel="noopener"> <em
                                                class="icon-download m-l-10"></em>
                                            </a>
                                            <a *ngIf="isDocChat" (click)="DocChat(attach,insight.ins_id)" class="ex_icon t-bottom t-sm"
                                              data-tooltip="Doc Chat" rel="noopener"> <em class="icon-chat m-l-10"></em>
                                            </a>
                                          </div>
                                        </ng-container>
                                      </p>
                                      <br>
                                      <p class="p-t-0" *ngIf="insight.countries">
                                        <span>Markets: {{data.countries}}</span>
                                        {{ displayCountries(insight.countries).firstTwo }}
                                        <a class="hyperlink"
                                          *ngIf="displayCountries(insight.countries).remainingCount > 0"
                                          (click)="ShowRegulationMarkets(insight.countries, insight.ins_id, insight.title)">
                                          +{{
                                          displayCountries(insight.countries).remainingCount }}</a>
                                      </p>
  
  
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
  
                          <!-- <app-regulation-markets-popup [showRegulationMarketsWindow]="ShowRegulationMarketsWindow"
                            [regulationId]="RegulationId" [regulationTitle]="RegulationTitle"
                            [regulationMarkets]="RegulationMarkets" (cancel)="handleCancel()">
                          </app-regulation-markets-popup> -->
                          <div class="popup-backdrop" *ngIf="ShowRegulationMarketsWindow">
                            <div class="popup">
                              <div class="popup-header">
                                <h1>Market Details ({{RegulationId}})</h1>
                              </div>
                              <div class="popup-body reg-markets">
                                <!-- <span class="reg-id"></span> -->
                                <span class="reg-title">{{RegulationTitle}}</span>
                                <p>Markets: {{RegulationMarkets}}</p>
                              </div>
                              <div class="popup-footer">
                                <button (click)="CancelShowRegulationMarketsWindow()"
                                  class="button primary">Close</button>
                              </div>
                            </div>
                          </div>
  
  
                          <div
                            *ngIf="isMetadataNotEmpty(chatdata.metadata)  && selected_module_name == 'view_access_to_rtq'">
                            <app-rtq-metadata [chatdata]="chatdata" [configdata]="configdata"></app-rtq-metadata>
                          </div>
                          <div
                            *ngIf="isMetadataNotEmpty(chatdata.metadata) && !note && (selected_module_name == 'view_access_to_racsstandard' || selected_module_name == 'view_access_to_freya_racs_probiotics_data' || selected_module_name == 'view_access_to_freya_racs_claims_data')">
                            <app-racs-metadata [chatdata]="chatdata" [configdata]="configdata"></app-racs-metadata>
                          </div>
  
                        
                          <div *ngIf="isOptionsEnable && chatdata.modified_date" class="timestamp">
                            <img src="./assets/images/icon-clock.svg" alt="Timestamp" title="Timestamp" />
                            <small>{{ chatdata.modified_date | date:'medium' }}</small>
                          </div>
  
                          <div class="row response-icons m-t-16" *ngIf="isOptionsEnable">
                            <div class="col-12">
                              <button title="Like" [ngClass]="{'icon-selected': chatdata.LikeClassAdded}"
                                (click)="LikeDisLike(chatdata,chatdata.pk_chathistoryid, chatdata.LikeClassAdded)"
                                type="button" class="btn" id='like_button'>
                                <i class="icon-thumbs-up"></i>
                              </button>
                              <button title="Unlike" [ngClass]="{'icon-selected': chatdata.disLikeClassAdded}"
                                (click)="DisLikeclick(chatdata,chatdata.pk_chathistoryid, chatdata.disLikeClassAdded)"
                                type="button" class="btn" id='dislike_button'>
                                <i class="icon-thumbs-down"></i>
                              </button>
                            </div>
                          </div>
                          <div class="row" *ngIf="chatdata.SubmitFeedback">
                            <div class="feed-back-section">
                              <p class="m-t-0 m-b-10">
                                {{configdata.DisLikeMessage}}
                              </p>
                              <div class="row">
                                <ul class="feedback-list">
  
                                  <li *ngFor="let item of chatdata.FeedbackOptions; let k = index">
                                    <input type="checkbox" id="control_{{item.pk_chathistoryid}}_{{item.Id}}"
                                      name="select_{{item.pk_chathistoryid}}_{{item.Id}}" [value]="item.Id"
                                      [(ngModel)]="item.IsChecked">
                                    <label for="control_{{item.pk_chathistoryid}}_{{ item.Id}}">
                                      {{ item.Name }}
                                    </label>
                                  </li>
                                </ul>
                              </div>
                              <!-- /* istanbul ignore next */ -->
                              <div class="row display-inline-block">
                                <div class="form-group m-t-10">
                                  <label for="additionalComments" class="label">Additional Comments</label>
                                  <textarea id="additionalComments" class="form-control"
                                    [(ngModel)]="chatdata.AdditionalComments" cols="3"
                                    placeholder="Provide additional comments, if required."></textarea>
                                  <span *ngIf="!isAnyOptionChecked(chatdata.FeedbackOptions) && chatdata.ErrorMsg"
                                    class="error_message">
                                    Please select at least one Feedback Option.
                                  </span>
                                </div>
                              </div>
                              <div class="row display-inline-block">
                                <div class="form-group m-t-20 text-right pull-right">
                                  <a href="#" class="btn btn-secondary-outline" (click)="clearCheckboxes(chatdata)">
                                    Cancel</a>
                                  <a href="#" class="btn btn-primary m-l-10"
                                    (click)="Dislikesubmit(chatdata,chatdata.pk_chathistoryid, false)"> Submit</a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row"
                            *ngIf="(chatdata.disLikeClassAdded && !chatdata.SubmitFeedback) || chatdata.LikeClassAdded">
                            <div class="feed-back-section" id='greeting_message'>
                              <p class="m-0">Thanks for helping me evolve. Your feedback is highly appreciated and will be
                                taken into consideration.</p>
                            </div>
                          </div>
                          <div class="row" *ngIf="chatdata.followUpQuestions && chatdata.followUpQuestions[0] && chatdata.followUpQuestions[0].length > 0">
                            <div class="col-12 followup-questions-total">
                              <h6 class="font-subheading1 m-t-20 m-b-15">Related Questions</h6>
                              <div class="followup-questions-list"
                                *ngFor="let fq of chatdata.followUpQuestions;let i = index">
                                <div *ngFor="let item of fq;">
                                  <a href="javascript: void(0)" (click)="FollowUpQuestionClick(item.Question)"
                                    [id]='"follow_up_question_link" + i'>{{item.Question}}</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="(chatCount !== (ChatQueriesList.length - 1))">
                    </div>
  
                  </div>
                </div>
              </div>
  
              <div #scrollContainer class="lastDiv" *ngFor="let chatdata of ChatQueriesList;  let chatCount = index">
  
                <div *ngIf="(chatCount === (ChatQueriesList.length - 1))">
                  <div class="card position-relative radius-6">
                    <div class="d-flex align-items-center justify-content-between m-b-8 p-l-2">
                      <div class="d-flex align-items-center fullwidth">
                        <div class="card-text-name m-r-22">{{DisplayName}}</div>
                        <div *ngIf="!showEdit" class="card-text-prompt">
                          <h6 class="font-subheading1 m-t-0 m-b-0 text-line20" [innerHtml]="chatdata.question"
                            id='relative_question_div'></h6>
                        </div>
                        <div *ngIf="showEdit" class="card-text-prompt">
                          <span class="black-400" contenteditable="false" (input)="onSpanInput($event)"
                            [innerHtml]="chatdata.question"></span>
  
                        </div>
                      </div>
                    </div>
  
                    <!-- /* istanbul ignore next */ -->
                    <div class="card pull-left p-l-10 fullwidth class2">
                      <div class="response-info-total class2">
                        <div class="response-info-icon">
                         <img src="../../assets/images/chatbot-icon.svg" alt="Freya">
                        </div>
                        <div class="response-info-text">
                          <div class="row m-b-20">
                            <div class="col-12">
                              <p class="m-t-0 m-b-10" [innerHtml]="chatdata.answer | replaceDoubleStar | safeHtml "></p>
                            </div>
                          </div>
                          <div *ngIf="IsLoader && selected_module_name == 'view_access_to_grade_data'"  aria-busy="true">
                            <div class="row">
                              <ng-container *ngFor="let _ of [0, 1]">
                                <div class="col-6 display-grid m-b-15">
                                  <div>
                                    <div class="product-panel__bg1">
                                      <div class="product_panel">
                                        <h4 class="skeleton skeleton-text" aria-hidden="true"></h4>
                                      </div>
                                      <div class="product_panel_body">
                                        <p class="p-b-10 skeleton skeleton-text" aria-hidden="true"><span class="skeleton-loader-span">....................................</span></p>
                                        <p class="p-b-10 skeleton skeleton-text" aria-hidden="true"><span class="skeleton-loader-span">....................</span></p>
                                        <p class="p-b-10 skeleton skeleton-text" aria-hidden="true"><span class="skeleton-loader-span">.................</span></p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                          <div
                            *ngIf="(chatdata.metadata|json)!='{}' && !note && selected_module_name == 'view_access_to_regulations'">
                            <div *ngFor="let data of getMetadataForDisplay(chatdata);" class="row">
  
                              <div *ngFor="let insight of data| keys let i = index" class="col-6 display-grid m-b-15">
                                <div>
                                  <div class="product-panel__bg1">
                                    <div class="product_panel">
                                      <a target="_blank" class="m-b-4" [href]="getInsightViewURLForHref(insight?.ins_id)"
                                        rel="noopener">
                                        {{insight?.ins_id}}
                                      </a>
                                      <h4>{{i+1}}. {{insight?.title | slice:0:62}}{{insight?.title && insight.title.length > 62 ? '...' : ''
                                        }}</h4>
                                    </div>
                                    <div class="product_panel_body">
                                      <p class="p-b-4" *ngIf="insight.ref_url">
                                        <span>Reference: </span>
                                        <ng-container *ngFor="let url of insight?.ref_url | refUrl let i = index">
                                          <span *ngIf="i != 0">, </span>
                                          <a [href]="url" target="_blank">Reference {{i+1}}</a>
                                        </ng-container>
                                      </p>
                                      <p class="p-b-4" *ngIf="insight.attachment_name">
                                        <span class="pull-left">Associated Documents :&nbsp; </span>
  
                                        <ng-container
                                          *ngFor="let attach of insight?.attachment_name | attachmentName let att = index">
                                          <div class="associate-doc-list">
                                            <span *ngIf="att != 0">, </span>
                                            <a (click)="viewFile(attach,'newTab',insight.ins_id)" rel="noopener"> Document {{att+1}} </a>
                                            <a (click)="viewFile(attach,'sameTab',insight.ins_id)" class="ex_icon t-bottom t-sm"
                                              data-tooltip="Download" rel="noopener"> <em
                                                class="icon-download m-l-10"></em>
                                            </a>
                                            <a *ngIf="isDocChat" (click)="DocChat(attach,insight.ins_id)" class="ex_icon t-bottom t-sm"
                                              data-tooltip="Doc Chat" rel="noopener"> <em class="icon-chat m-l-10"></em>
                                            </a>
                                          </div>
                                        </ng-container>
                                      </p>
                                      <br>
                                      <p class="p-t-0" *ngIf="insight.countries">
                                        <span>Markets: {{data.countries}}</span>
                                        {{ displayCountries(insight.countries).firstTwo }}
                                        <a class="hyperlink"
                                          *ngIf="displayCountries(insight.countries).remainingCount > 0"
                                          (click)="ShowRegulationMarkets(insight.countries, insight.ins_id, insight.title)">
                                          +{{
                                          displayCountries(insight.countries).remainingCount }}</a>
                                      </p>
  
  
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
  
                          <!-- <app-regulation-markets-popup [showRegulationMarketsWindow]="ShowRegulationMarketsWindow"
                            [regulationId]="RegulationId" [regulationTitle]="RegulationTitle"
                            [regulationMarkets]="RegulationMarkets" (cancel)="handleCancel()">
                          </app-regulation-markets-popup> -->
  
                          <div class="popup-backdrop" *ngIf="ShowRegulationMarketsWindow">
                            <div class="popup">
                              <div class="popup-header">
                                <h1>Market Details ({{RegulationId}})</h1>
                              </div>
                              <div class="popup-body reg-markets">
                                <!-- <span class="reg-id">{{RegulationId}}</span> -->
                                <span class="reg-title">{{RegulationTitle}}</span>
                                <p>Markets: {{RegulationMarkets}}</p>
                              </div>
                              <div class="popup-footer">
                                <button (click)="CancelShowRegulationMarketsWindow()"
                                  class="button primary">Close</button>
                              </div>
                            </div>
                          </div>
  
                          <div
                            *ngIf="isMetadataNotEmpty(chatdata.metadata) && selected_module_name == 'view_access_to_rtq'">
                            <app-rtq-metadata [chatdata]="chatdata" [configdata]="configdata"></app-rtq-metadata>
                          </div>
                          <div
                            *ngIf="isMetadataNotEmpty(chatdata.metadata) && (selected_module_name == 'view_access_to_racsstandard' || selected_module_name == 'view_access_to_freya_racs_probiotics_data' || selected_module_name == 'view_access_to_freya_racs_claims_data')">
                            <app-racs-metadata [chatdata]="chatdata" [configdata]="configdata"></app-racs-metadata>
                          </div>
                          <!-- <div
                            *ngIf="isMetadataNotEmpty(chatdata.metadata) && selected_module_name == 'view_access_to_grade_data'">
                            <app-otsuka-metadata [chatdata]="chatdata" [configdata]="configdata"
                              [sessionId]="sessionIdArray" [tenantId]="tenantID" [domainId]="DomainID" [userId]="UserID">
                            </app-otsuka-metadata>
                          </div> -->
                          <div
                            *ngIf="isMetadataNotEmpty(chatdata.metadata) && selected_module_name == 'access_to_iyc_data'">
                            <app-iyc-metadata [chatdata]="chatdata" [configdata]="configdata"></app-iyc-metadata>
                          </div>
  
                          <div *ngIf="isOptionsEnable && chatdata.modified_date" class="timestamp">
                            <img src="./assets/images/icon-clock.svg" alt="Timestamp" title="Timestamp" />
                            <small>{{ chatdata.modified_date | date:'medium' }}</small>
                          </div>
  
                          <div class="note-helptext m-b-20" *ngIf="note && configdata.isNoteInfo">
                            <div class="row">
                              <div class="col-1 display-flex">
                                <img src="./assets/images/info.svg" alt="Note" title="Note" />
                              </div>
                              <div class="col-11" [innerHtml]="configdata.NoteInfo">
                              </div>
                            </div>
                          </div>
                          <div class="row response-icons m-t-16" *ngIf="isOptionsEnable">
                            <div class="col-12">
                              <button title="Like" [ngClass]="{'icon-selected': chatdata.LikeClassAdded}"
                                (click)="LikeDisLike(chatdata,chatdata.pk_chathistoryid,chatdata.LikeClassAdded)"
                                type="button" class="btn" id='like_button'>
                                <i class="icon-thumbs-up"></i>
                              </button>
                              <button title="Unlike" [ngClass]="{'icon-selected': chatdata.disLikeClassAdded}"
                                (click)="DisLikeclick(chatdata,chatdata.pk_chathistoryid, chatdata.disLikeClassAdded)"
                                type="button" class="btn" id='dislike_button'>
                                <i class="icon-thumbs-down"></i>
                              </button>
                              <div class="dropdown" *ngIf="!note" id='options_dropdown'>
                                <input title="Options" class="dropdown-toggle" type="text">
                                <div class="dropdown-text"> <i class="icon-preferences"></i></div>
                                <ul class="dropdown-content">
                                  <li><a href="javascript: void(0)" id='regenerate_response_button'
                                      (click)="RegenerateActions(chatdata.question,'Regenerate')">
                                      <i class="icon-reload1"></i> Regenerate your response</a></li>
                                  <li><a href="javascript: void(0)" id='make_response_crisp_button'
                                      (click)="RegenerateActions(chatdata.question,'Shorter')">
                                      <i class="icon-collapse"></i> Make the response crisp</a></li>
                                  <li><a href="javascript: void(0)" id='give_detailed_response_button'
                                      (click)="RegenerateActions(chatdata.question,'Longer')">
                                      <i class="icon-expand"></i>
                                      Give me a detailed response</a></li>
                                </ul>
                              </div>
                            </div>
                          </div>
  
                        </div>
                        <div class="row" *ngIf="chatdata.SubmitFeedback">
                          <div class="feed-back-section">
                            <h1 class="m-t-0 m-b-10">Provide additional feedback</h1>
                            <p class="m-t-0 m-b-10">
                              {{configdata.DisLikeMessage}}
                            </p>
                            <div class="row">
                              <div class="col-12">
                                <ul class="feedback-list" id='feedback_options_list'>
                                  <li *ngFor="let item of chatdata.FeedbackOptions; let k = index">
                                    <input type="checkbox" id="control_{{item.pk_chathistoryid}}_{{item.Id}}"
                                      name="select_{{item.pk_chathistoryid}}_{{item.Id}}" [value]="item.Id"
                                      [(ngModel)]="item.IsChecked">
                                    <label for="control_{{item.pk_chathistoryid}}_{{ item.Id}}"
                                      [id]='"feedback_option" + k'>
                                      {{ item.Name }}
                                    </label>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="row display-inline-block">
                              <div class="form-group m-t-10">
                                <label for="additionalComments" class="label">Additional Comments</label>
                                <textarea id="additionalComments" class="form-control"
                                  [(ngModel)]="chatdata.AdditionalComments" cols="3"
                                  placeholder="Provide additional comments, if required."
                                  id='additional_comments_text_area'></textarea>
                                <span *ngIf="!isAnyOptionChecked(chatdata.FeedbackOptions) && chatdata.ErrorMsg"
                                  class="error_message" id='feedback_error_message'>
                                  Please select at least one Feedback Option.
                                </span>
                              </div>
                            </div>
                            <div class="row display-inline-block">
                              <div class="form-group m-t-20 text-right pull-right">
                                <a href="#" class="btn btn-secondary-outline" (click)="clearCheckboxes(chatdata)"
                                  id='feedback_cancel_button'>
                                  Cancel</a>
                                <a href="#" class="btn btn-primary m-l-10" id='feedback_submit_button'
                                  (click)="Dislikesubmit(chatdata,chatdata.pk_chathistoryid, false)"> Submit</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row"
                          *ngIf="(chatdata.disLikeClassAdded && !chatdata.SubmitFeedback) || chatdata.LikeClassAdded">
                          <div class="feed-back-section" id='greeting_message'>
                            <p class="m-0">Thanks for helping me evolve. Your feedback is highly appreciated and will be
                              taken into consideration.</p>
                          </div>
                        </div>
                        <div class="row" *ngIf="chatdata.followUpQuestions?.[0]?.length > 0">
                          <div class="col-12 followup-questions-total">
                            <h6 class="font-subheading1 m-t-20 m-b-15">Related Questions</h6>
                            <div class="followup-questions-list"
                              *ngFor="let fq of chatdata.followUpQuestions;let i = index">
                              <div *ngFor="let item of fq;">
                                <a href="javascript: void(0)" (click)="FollowUpQuestionClick(item.Question)"
                                  [id]='"follow_up_question_link" + i'>{{item.Question}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
  
                      </div>
  
  
  
                    </div>
  
                  </div>
                </div>
              </div>
  
            </div>
          </div>
          <div class="chat-expandable-area" *ngIf="IsFirstTime">
            <app-newchat [moduleName]="moduleName" [userFName]="userFName"
              (buttonClick)="PopularQuestionClick($event)"></app-newchat>
          </div>
  
          <div class="prompt-section position-relative" [ngClass]="{'fist-time-formprompt': IsFirstTime}">
            <div class="prompt-box-top" [ngClass]="{'prompt-no-ddl': vectorDbDatasets.length == 1}">
              <div class="domain-switch-container" *ngIf="isDomainManagementEnabled">
                <app-domain-switch
                  [textareaElement]="autoResizeTextarea"
                  [allDomainNames]="allDomainNamesList"
                  [currentSelectedDomain]="currentSelectedDomain"
                  [isNewChatbotEnabled]="false"
                  (suggestionSelected)="onDomainSelected($event)"
                  (newChatRequested)="ClickNewChat(true)">
                </app-domain-switch>
              </div>
              <select class="privileges-ddl" *ngIf="vectorDbDatasets.length>0" [(ngModel)]="selectedVectorDbDataset"
                (change)="handleChange()" [style.display]="vectorDbDatasets.length == 1 ? 'none' : 'block'"
                id="dropdown_selector">
                <option *ngFor="let option of vectorDbDatasets; let i= index" [ngValue]="option"
                  [id]="'dropdown_options' + i">{{option.name}} </option>
              </select>
              <div class="prompt-btns">
  
                <button title="history" (click)="DisplayChatHistory()" class="btn btn-history m-r-8 t-top"
                  data-tooltip="Conversation History" id='chat-history-button' rel="noopener"
                  *ngIf="isChatSessionListValid()">
                  <i class="icon-history" id='chat-history-icon-i'></i>
                </button>
  
                <button type="button" class="btn btn-newchat" (click)="ClickNewChat(true)" id='new_topic_button'>
                  <img src="../../assets/images/newchat-icon.svg" alt="New Topic" class="m-r-8">
  
                  <span>New Topic</span></button>
              </div>
            </div>
  
            <div class="form-input  flex-col">
  
              <textarea #autoResizeTextarea appAutoResizeTextarea class="form-prompt" (keydown.enter)="onEnterPress($event)"
                [(ngModel)]="txtChat" placeholder="Ask or search anything." id='text_area'></textarea>
              <div class="form-send position-absolute">
                <a title="search" href="javascript: void(0)" class="text-white" (click)="SendRequest(false)"
                  *ngIf="!IsResponseStreaming">
                  <!-- /* istanbul ignore next */ -->
                  <svg class="rocket-animate" enable-background="new 0 0 512 512" version="1.1" viewBox="0 0 512 512"
                    xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                    <linearGradient id="h" x1="65.64" x2="479.69" y1="239.32" y2="239.32" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0c5ef7" offset="0" />
                      <stop stop-color="#3162bd" offset="1" />
                    </linearGradient>
                    <path id="rocketarea"
                      d="m478.18 73.709-114.04 342.05c-11.293 37.604-66.408 41.704-83.014 5.917l-59.262-118.52c-0.16-0.4-0.4-0.72-0.56-1.12l11.597-11.596 94.13-94.21c3.122-3.105 3.136-8.154 0.031-11.276s-8.154-3.136-11.276-0.031l-0.031 0.031c-5.404 5.38-104.85 104.77-105.81 105.73-0.4-0.16-0.72-0.4-1.12-0.559l-118.52-59.263c-35.601-16.479-31.82-71.742 5.92-83.014l342.05-114.04c16.69-5.35 34.558 3.843 39.907 20.534 2.02 6.3 2.02 13.074 0 19.374z"
                      fill="url(#h)" />
                    <linearGradient id="f" x1="169.48" x2="231.2" y1="449.14" y2="449.14" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0c5ef7" offset="0" />
                      <stop stop-color="#3162bd" offset="1" />
                    </linearGradient>
                    <path id="rocketlast"
                      d="m217.65 420.51-45.829 45.833c-3.126 3.119-3.132 8.182-0.013 11.309s8.182 3.132 11.309 0.013l0.013-0.013 45.829-45.833c3.065-3.181 2.97-8.244-0.211-11.309-3.098-2.984-8.001-2.984-11.098 0z"
                      fill="url(#f)" />
                    <linearGradient id="g" x1="77.816" x2="162.45" y1="391.85" y2="391.85" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0c5ef7" offset="0" />
                      <stop stop-color="#3162bd" offset="1" />
                    </linearGradient>
                    <path id="rocketmiddle"
                      d="m148.91 351.76-68.751 68.748c-3.123 3.123-3.123 8.186 0 11.309s8.186 3.123 11.309 0l68.751-68.748c3.061-3.185 2.96-8.248-0.225-11.309-3.097-2.975-7.989-2.975-11.084 0z"
                      fill="url(#g)" />
                    <linearGradient id="e" x1="-362.06" x2="-354.35" y1="611.36" y2="611.36"
                      gradientTransform="matrix(8 0 0 -8 2928.5 5202.5)" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0c5ef7" offset="0" />
                      <stop stop-color="#3162bd" offset="1" />
                    </linearGradient>
                    <path id="rocketfirst"
                      d="m80.158 283.02-45.828 45.833c-3.123 3.123-3.123 8.186 0 11.309s8.186 3.123 11.309 0l45.829-45.833c3.06-3.185 2.958-8.249-0.227-11.309-3.097-2.973-7.987-2.973-11.083 0z"
                      fill="url(#e)" />
                  </svg>
                </a>  
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 disclaimer">
              Freya may occasionally not give the desired output. Reviewing key information is recommended.
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>